import { Pipe, PipeTransform } from '@angular/core';
import { translate } from '../utils/translation.util';

@Pipe({ name: 'translate' })
export class TranslatePipe implements PipeTransform {
    transform(source: string | string[]) {
        if (typeof source === 'string') {
            return translate(source);
        } else {
            return source.map(v => translate(v));
        }
    }
}